import React, {  } from 'react';


const ScriptLink = (props) => {
    return(
        <p className='font-medium sm:text-sm'><span className='text-purple-500'>const</span> <span className='text-green-500'>{props.title}</span> = <a className='text-orange-400' href={props.link}>{`"`}<span className='underline'>{props.link}</span>{`"`}</a></p>
    );
}


export default ScriptLink;